var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "assistant-cat-dialog-mask" }, [
    _c(
      "div",
      {
        staticClass: "assistant-cat-dialog-content",
        on: {
          click: function ($event) {
            $event.stopPropagation()
          },
        },
      },
      [
        _c("div", { staticClass: "dialog-header" }, [
          _c("h2", { staticClass: "dialog-title" }, [
            _vm._v(_vm._s(_vm.$t("myPage.assistantCatDialog.title"))),
          ]),
          _c(
            "button",
            {
              staticClass: "close-button",
              attrs: {
                "aria-label": _vm.$t(
                  "myPage.assistantCatDialog.closeAriaLabel"
                ),
              },
              on: { click: _vm.handleClose },
            },
            [_c("span", { staticClass: "close-icon" }, [_vm._v("×")])]
          ),
        ]),
        _vm.isLoading
          ? _c(
              "div",
              { staticClass: "loading-container" },
              [
                _c("LoadingSpinner", {
                  attrs: {
                    size: "large",
                    variant: "overlay",
                    text: _vm.$t("myPage.assistantCatDialog.loadingText"),
                  },
                }),
              ],
              1
            )
          : _vm.error
          ? _c("div", { staticClass: "error-container" }, [
              _c("p", { staticClass: "error-message" }, [
                _vm._v(_vm._s(_vm.error)),
              ]),
              _c(
                "button",
                { staticClass: "retry-button", on: { click: _vm.handleRetry } },
                [
                  _vm._v(
                    _vm._s(_vm.$t("myPage.assistantCatDialog.retryButton"))
                  ),
                ]
              ),
            ])
          : _c("div", { staticClass: "dialog-body" }, [
              _c("p", { staticClass: "description" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("myPage.assistantCatDialog.descriptionLine1"))
                ),
                _c("br"),
                _vm._v(
                  _vm._s(_vm.$t("myPage.assistantCatDialog.descriptionLine2")) +
                    " "
                ),
              ]),
              _c(
                "div",
                { staticClass: "group-tabs" },
                _vm._l(_vm.groupOptions, function (group) {
                  return _c(
                    "button",
                    {
                      key: group.code,
                      staticClass: "group-tab",
                      class: {
                        "group-tab--active": _vm.selectedGroup === group.code,
                        [`group-tab--${group.code.toLowerCase()}`]:
                          _vm.selectedGroup === group.code,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleGroupSelect(group.code)
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "group-icon",
                        attrs: {
                          src: _vm.getGroupIcon(group.code),
                          alt:
                            group.name +
                            _vm.$t("myPage.assistantCatDialog.groupIconSuffix"),
                        },
                      }),
                      _c("span", [_vm._v(_vm._s(group.name))]),
                    ]
                  )
                }),
                0
              ),
              _c(
                "div",
                { staticClass: "carousel-container" },
                [
                  _c(
                    "swiper",
                    {
                      ref: "catSwiper",
                      staticClass: "cat-swiper",
                      attrs: { options: _vm.swiperOptions },
                    },
                    [
                      _vm._l(_vm.filteredCats, function (cat) {
                        return _c(
                          "swiper-slide",
                          {
                            key: cat.assistantCatType,
                            staticClass: "cat-slide",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "cat-card",
                                class: {
                                  "cat-card--selected": cat.selected,
                                  "cat-card--writer-type": _vm.isWriterTypeCat(
                                    cat
                                  ),
                                  "cat-card--premium-prompt": _vm.shouldShowPremiumPrompt(
                                    cat
                                  ),
                                },
                              },
                              [
                                _c("div", { staticClass: "cat-group-badge" }, [
                                  _c("img", {
                                    staticClass: "cat-group-icon",
                                    attrs: {
                                      src: _vm.getGroupIcon(cat.group),
                                      alt:
                                        cat.groupName +
                                        _vm.$t(
                                          "myPage.assistantCatDialog.groupSuffix"
                                        ),
                                    },
                                  }),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "cat-icon-container" },
                                  [
                                    _c("CatIcon", {
                                      attrs: {
                                        "writer-type": cat.assistantCatType,
                                        clickable: false,
                                        size: "large",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "cat-names" }, [
                                  _c(
                                    "div",
                                    { staticClass: "cat-name-japanese" },
                                    [_vm._v(_vm._s(cat.officialNameJapanese))]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "cat-name-english" },
                                    [_vm._v(_vm._s(cat.officialName))]
                                  ),
                                ]),
                                _c("div", { staticClass: "cat-status" }, [
                                  _vm.isWriterTypeCat(cat)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "status-label status-label--writer-type",
                                          class: `status-label--${cat.group.toLowerCase()}`,
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "myPage.assistantCatDialog.writerTypeLabel"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : cat.isSynergyType
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "status-label status-label--synergy",
                                          class: `status-label--${cat.group.toLowerCase()}`,
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "myPage.assistantCatDialog.synergyTypeLabel"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : cat.isImpactType
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "status-label status-label--impact",
                                          class: `status-label--${cat.group.toLowerCase()}`,
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "myPage.assistantCatDialog.impactTypeLabel"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _c("p", { staticClass: "cat-description" }, [
                                  _vm._v(_vm._s(cat.description)),
                                ]),
                                _c("div", { staticClass: "cat-action" }, [
                                  cat.selected
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "action-button action-button--disabled",
                                          attrs: { disabled: "" },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "myPage.assistantCatDialog.selectedButton"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "button",
                                        {
                                          staticClass:
                                            "action-button action-button--active",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleSelectCat(cat)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "myPage.assistantCatDialog.changeButton"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                ]),
                                _vm.shouldShowPremiumPrompt(cat)
                                  ? _c(
                                      "div",
                                      { staticClass: "premium-prompt-overlay" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "premium-prompt-content",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "premium-prompt-message",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "premium-badge",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: require("@/assets/img/icon/premium.png"),
                                                        width: "24",
                                                        height: "24",
                                                        alt: "Premium",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "premium-prompt-main-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "myPage.assistantCatDialog.premiumPrompt"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "premium-prompt-actions",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "premium-register-button",
                                                    on: {
                                                      click: _vm.onClickUpgrade,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "myPage.assistantCatDialog.registerButton"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      }),
                      _c("div", {
                        staticClass: "swiper-button-prev",
                        attrs: { slot: "button-prev" },
                        slot: "button-prev",
                      }),
                      _c("div", {
                        staticClass: "swiper-button-next",
                        attrs: { slot: "button-next" },
                        slot: "button-next",
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }